// extracted by mini-css-extract-plugin
module.exports = {"intro":"jobintro-module--intro--1mTOU","heading":"jobintro-module--heading--GSoLQ","para":"jobintro-module--para--1mC3S"};